/* /pages/stanton-fabrics: fabric wall filters, swatch sheet, chat hooks and consent-gated GA4 events.
   Progressive enhancement: without this file every fabric, grade and answer is still on the page. */
(() => {
  'use strict';
  if (window.wnfswFabricsInitialized) return;
  window.wnfswFabricsInitialized = true;
  const measurementId = 'G-0JE425EEKS';
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const track = (name, params = {}) => {
    if (!allowed() || typeof window.gtag !== 'function') return;
    window.gtag('event', name, { send_to: measurementId, page_location: 'https://whatsnewfurniture.com/pages/stanton-fabrics', ...params });
  };
  if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
  }
  const PRICE = { Standard: 'Base price for the frame and size you pick.', Premium: '+$60 on a sofa, more on big sectionals.', Performance: '+$120 on a sofa, more on big sectionals.' };
  const CODE = { W: 'W: water-based foam cleaner.', S: 'S: water-free solvent cleaner only.', WS: 'WS: water-based or solvent cleaner.', X: 'X: vacuum or brush only.', '': 'Ask us about this one.' };
  const init = () => {
    const page = document.querySelector('[data-wnfsw-stanton-fabrics-page]');
    if (!page) return;
    const wall = page.querySelector('#wsf-wall');
    const grid = wall.querySelector('[data-wsf-grid]');
    const items = [...grid.children];
    const count = wall.querySelector('[data-wsf-count]');
    const reset = wall.querySelector('[data-wsf-reset]');
    const more = wall.querySelector('[data-wsf-showall]');
    const grades = [...wall.querySelectorAll('[data-wsf-grade]')];
    const colors = [...wall.querySelectorAll('[data-wsf-color]')];
    let grade = null, color = null, expanded = false;
    grid.classList.add('is-collapsed');
    more.hidden = false;
    const apply = () => {
      const filtering = !!(grade || color);
      let n = 0;
      items.forEach((li) => {
        const ok = (!grade || li.dataset.g === grade) && (!color || li.dataset.b === color);
        li.hidden = !ok;
        if (ok) n++;
      });
      grid.classList.toggle('is-collapsed', !filtering && !expanded);
      more.hidden = filtering || expanded;
      reset.hidden = !filtering;
      grades.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.wsfGrade === grade)));
      colors.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.wsfColor === color)));
      const colorLabel = color ? colors.find((b) => b.dataset.wsfColor === color).textContent.trim().toLowerCase() : '';
      count.textContent = filtering ? `Showing ${n} ${grade ? grade + ' ' : ''}fabric${n === 1 ? '' : 's'}${color ? ' in ' + colorLabel : ''}` : 'Showing all 167 fabrics';
    };
    grades.forEach((b) => b.addEventListener('click', () => {
      grade = grade === b.dataset.wsfGrade ? null : b.dataset.wsfGrade;
      apply();
      track('wnf_stanton_fabrics_filter', { filter: 'grade_' + (grade || 'all') });
    }));
    colors.forEach((b) => b.addEventListener('click', () => {
      color = color === b.dataset.wsfColor ? null : b.dataset.wsfColor;
      apply();
      track('wnf_stanton_fabrics_filter', { filter: 'color_' + (color || 'all') });
    }));
    reset.addEventListener('click', () => { grade = null; color = null; apply(); track('wnf_stanton_fabrics_filter', { filter: 'reset' }); });
    more.addEventListener('click', () => {
      expanded = true; apply();
      const next = items[24]?.querySelector('button');
      if (next) next.focus({ preventScroll: true });
      track('wnf_stanton_fabrics_filter', { filter: 'show_all' });
    });
    page.querySelectorAll('[data-wsf-jump]').forEach((a) => a.addEventListener('click', () => {
      grade = a.dataset.wsfJump; apply();
      track('wnf_stanton_fabrics_filter', { filter: 'grade_' + grade, source: 'ruler' });
    }));
    const sheet = wall.querySelector('[data-wsf-sheet]');
    const $ = (sel) => sheet.querySelector(sel);
    const tiles = [...grid.querySelectorAll('[data-wsf-swatch]')];
    const picked = page.querySelector('[data-wsf-picked]');
    let opener = null, current = null;
    const fill = (t) => {
      const d = t.dataset;
      current = d;
      const img = $('[data-wsf-sheet-img]');
      img.src = d.src + '?width=900';
      img.alt = 'Stanton ' + d.n + ' fabric swatch, close up';
      $('[data-wsf-sheet-name]').textContent = d.n;
      $('[data-wsf-sheet-grade]').textContent = d.g + ' grade, ' + d.bl.toLowerCase();
      $('[data-wsf-sheet-price]').textContent = PRICE[d.g] || '';
      $('[data-wsf-sheet-code]').textContent = CODE[d.c] ?? CODE[''];
      $('[data-wsf-sheet-content]').textContent = d.ct;
      $('[data-wsf-frames]').textContent = 'Pick a frame for ' + d.n;
      $('[data-wsf-sheet-ask]').textContent = 'Ask for a photo of ' + d.n;
      $('[data-wsf-sheet-help]').textContent = "Note the name: you'll choose " + d.n + " in the builder's " + d.g + ' fabrics.';
      const more = $('[data-wsf-sheet-more]');
      const row = $('[data-wsf-sheet-more-row]');
      const mates = d.line ? tiles.filter((x) => x.dataset.line === d.line && x.dataset.n !== d.n) : [];
      row.textContent = '';
      mates.slice(0, 8).forEach((m) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'wsf-sheet-mate';
        b.setAttribute('aria-label', m.dataset.n + ', ' + m.dataset.g);
        const i = document.createElement('img');
        i.src = m.dataset.src + '?width=120'; i.alt = ''; i.width = 52; i.height = 52; i.loading = 'lazy';
        const n = document.createElement('span');
        n.textContent = m.dataset.n.slice(d.line.length).trim();
        b.append(i, n);
        b.addEventListener('click', () => { fill(m); track('wnf_stanton_fabrics_swatch_open', { fabric: m.dataset.n, grade: m.dataset.g, source: 'more_colors' }); });
        row.append(b);
      });
      $('[data-wsf-sheet-more-title]').textContent = 'More ' + d.line + ' colors';
      more.hidden = mates.length === 0;
    };
    grid.addEventListener('click', (e) => {
      const t = e.target.closest('[data-wsf-swatch]');
      if (!t || typeof sheet.showModal !== 'function') return;
      opener = t;
      fill(t);
      sheet.showModal();
      sheet.querySelector('.wsf-sheet-in').scrollTop = 0;
      track('wnf_stanton_fabrics_swatch_open', { fabric: t.dataset.n, grade: t.dataset.g });
    });
    sheet.addEventListener('click', (e) => { if (e.target === sheet) sheet.close(); });
    sheet.addEventListener('close', () => { if (opener) opener.focus({ preventScroll: true }); });
    $('[data-wsf-frames]').addEventListener('click', () => {
      if (!current) return;
      // Hand-off for the builders (they can preselect this fabric later; see REPORT "Shared changes needed").
      try { sessionStorage.setItem('wnf:stanton-fabric', JSON.stringify({ name: current.n, grade: current.g, at: Date.now() })); } catch (err) {}
      if (picked) {
        picked.textContent = 'You picked ' + current.n + ' (' + current.g + '). Open any frame below and choose ' + current.n + ' in its ' + current.g + ' fabrics.';
        picked.hidden = false;
      }
      opener = null;
      sheet.close();
    });
    // Capture phase so this runs before Motion's link handler starts a page transition.
    document.addEventListener('click', (e) => {
      const cta = e.target.closest('[data-wsf-cta]');
      if (cta && page.contains(cta)) track('wnf_stanton_fabrics_cta_click', { cta_placement: cta.dataset.wsfCta, transport_type: 'beacon' });
      const chat = e.target.closest('[data-wsf-chat]');
      if (chat && page.contains(chat) && typeof window.WNFChatOpen === 'function') {
        e.preventDefault();
        if (sheet.open) sheet.close();
        const intent = chat.dataset.wsfChat === 'photo' ? 'photo' : undefined;
        window.WNFChatOpen(intent ? { intent } : undefined);
        track('wnf_stanton_fabrics_chat_open', { cta_placement: chat.dataset.wsfCta || '', intent: intent || 'chat' });
      }
    }, true);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
